
export default {
  name: 'DateTime',
  values: {
    showTodayAndTomorrowLabels: false,
    format: 'SHORT_DATE_TIME',
    todayTomorrowFormat: 'SHORT_TIME',
    customFormatter: undefined,
  },
  meta: {
    extendable: false,
  },
}
